enum MediaHlsSegmentFormat {
  /** AAC packed audio elementary stream. */
  AAC = 'AAC',

  /** AC3 packed audio elementary stream. */
  AC3 = 'AC3',

  /** E-AC3 packed audio elementary stream. */
  E_AC3 = 'E-AC3',

  /** Audio packed in ISO BMPP CMAF Fragmented MP4. */
  FMP4 = 'FMP4',

  /** MP3 packed audio elementary stream. */
  MP3 = 'MP3',

  /** MPEG-2 transport stream. */
  TS = 'TS',

  /** AAC packed MPEG-2 transport stream. */
  TS_AAC = 'TS_AAC',
}

export default MediaHlsSegmentFormat
